import React from 'react';
import PropTypes from 'prop-types';

const VisibleComponent = ({ when, children }) => {
  if (!when) {
    return null;
  }

  return <>{children}</>;
};

VisibleComponent.propTypes = {
  when: PropTypes.bool,
  children: PropTypes.node
};

export default VisibleComponent;
